import { useState } from 'react';
import { Form, useCRUDController, Radio, Row, Col, Tag, Input, Modal } from './../../ui/ot'
import { SmartTaskSchedulingTaskTable } from "./../../pmis/smart_task_scheduling_task";
import NaturePersonFormItems from './../components/nature_person_form_items'
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { useRef } from 'react';

const NaturePersonManagement = ({
    propsForm,
    onFormFinish = () => { },
    defaultSelectedRowsInfo = [],
    defaultSelectedRowsKeys = [],
    keyPrefix = "queue_management.nature_person",
    mode = 'admin',
    propsShowKeys = [
        { key: "task_id", name: "task_id", hidden: false, require: false },
        { key: "start_time", name: "start_time", hidden: true, require: false },
        { key: "begin_time", name: "begin_time", hidden: false, require: false },
        { key: "row_number_partition_date_order_task_id", name: "row_number_partition_date_order_task_id", hidden: false, require: false },
        { key: "staff_id", name: "staff_id", hidden: false, require: false },
        { key: "serial_name", name: "serial_name", hidden: false, require: false },
        { key: "user_department_role_data", name: "user_department_role_data", hidden: false, require: false },
        { key: "staff_name", name: "staff_name", hidden: false, require: false },
        { key: "staff_english_name", name: "staff_english_name", hidden: true, require: false },
        { key: "birthday", name: "birthday", hidden: false, require: false },
        { key: "lunar_birthday", name: "lunar_birthday", hidden: true, require: false },
        { key: "staff_phone", name: "staff_phone", hidden: false, require: false },
        { key: "address", name: "address", hidden: false, require: false },
        { key: "email", name: "email", hidden: false, require: false },
        { key: "custom_line_id", name: "custom_line_id", hidden: true, require: false },
        { key: "task_name", name: "task_name", hidden: true, require: false },
        { key: "task_explaination", name: "task_explaination", hidden: true, require: false },
        { key: "person_in_charge", name: "person_in_charge", hidden: true, require: false },
        { key: "executor", name: "executor", hidden: true, require: false },
        { key: "end_time", name: "end_time", hidden: true, require: false },
        { key: "progress", name: "progress", hidden: true, require: false },
        { key: "category_name", name: "category_name", hidden: true, require: false },
        { key: "priority_name", name: "priority_name", hidden: true, require: false },
        { key: "label_name", name: "label_name", hidden: true, require: false },
        { key: "status_name", name: "status_name", hidden: true, require: false },
        { key: "application_submitted_text", name: "application_submitted_text", hidden: true, require: false },
        { key: "application_submitted_title", name: "application_submitted_title", hidden: false, require: false },
        { key: "create_staff_name", name: "create_staff_name", hidden: true, require: false },
    ],
    departmentMode = 'structure',
    ...props
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm || form_

    const [ModalOpen, setModalOpen] = useState(
        false
    )

    const getFormValues = () => {
        let values = {}
        values = form.getFieldsValue()
        return values
    }
    const onSelectChange = (selectedRowsInfo) => {
        form.setFieldsValue({ selectedRowsInfo: selectedRowsInfo })
    }

    const refStaffTimer = useRef(setTimeout(() => { }, 0));
    const staffController = useCRUDController({ apiRoute: '/organization_structure/api/staff' })
    const [staffForm] = Form.useForm()
    const formOnValuesChange = (formValues, { name } = {}, propsForm) => {
        if (String(name).endsWith('staff_name')) {
            const index = name.lastIndexOf('.');
            const result = name.substring(0, index);
            clearTimeout(refStaffTimer.current);
            refStaffTimer.current = setTimeout(() => {
                staffController.getData({
                    staff_name_only: propsForm.getFieldValue(result + '.staff_name'),
                }).then(response => {
                    if (response?.data?.length > 0) {
                        Modal.confirm({
                            title: '既有人員',
                            content: (<>
                                <Form
                                    form={staffForm}
                                >
                                    <Form.Item
                                        name={'staff'}
                                    >
                                        <Radio.Group>
                                            {response?.data?.map((item, index) => <>
                                                <Radio value={index}>姓名：{item?.staff_name}，生日：{item?.birthday}</Radio>
                                            </>)}
                                        </Radio.Group>
                                    </Form.Item>
                                </Form>
                            </>),
                            onOk: () => {
                                const staff = staffForm.getFieldValue('staff')
                                console.log(staffForm.getFieldsValue())
                                if (staff !== undefined) {
                                    console.log({ result })
                                    console.log({ staff })
                                    console.log({ staff: response?.data?.[staff] })
                                    propsForm.setFieldValue(result, {
                                        ...response?.data?.[staff]
                                    })
                                }
                            },
                            okText: '帶入資訊',
                            cancelText: '關閉'
                        })
                    }
                })
            }, 1000)
        }
    }

    return (
        <Row>
            <Col span={24}>
                <SmartTaskSchedulingTaskTable
                    initialValues={{
                        start_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    }}
                    api={`/queue_management/backend/natural_person`}
                    keyPrefix={keyPrefix}
                    propsModalOpen={ModalOpen}
                    propsSetModalOpen={setModalOpen}
                    defaultSelectedRowsInfo={defaultSelectedRowsInfo}
                    defaultSelectedRowsKeys={defaultSelectedRowsKeys}
                    onSelectChange={onSelectChange}
                    customColumns={[
                        {
                            title: t('application_submitted_text'),
                            sorter: false,
                            dataIndex: 'application_submitted_title',
                            key: 'application_submitted_title',
                            //width: "10rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    <Col>
                                        <Tag color={record?.application_submitted_text === '尚未申請通過' ? 'error' : 'geekblue'}>
                                            {record?.application_submitted_text}
                                        </Tag>
                                    </Col>
                                </Row>
                            </>
                        },
                        // {
                        //     title: t('task_id'),
                        //     sorter: true,
                        //     dataIndex: 'task_id',
                        //     key: 'task_id',
                        //     width: "10rem",
                        //     canFilter: true,
                        //     filterType: "search"
                        // },
                        // {
                        //     title: t('start_time'),
                        //     sorter: true,
                        //     dataIndex: 'start_time',
                        //     key: 'start_time',
                        //     width: "10rem",
                        //     canFilter: true,
                        //     filterType: "search",
                        // },
                        {
                            title: t('number'),
                            sorter: false,
                            dataIndex: 'row_number_partition_date_order_task_id',
                            key: 'row_number_partition_date_order_task_id',
                            //width: "3rem",
                            canFilter: false,
                            filterType: "search"
                        },
                        {
                            title: t('staff_id'),
                            sorter: false,
                            dataIndex: 'staff_id',
                            key: 'staff_id',
                            //width: "5rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.staff_id}
                                </Row>
                            </>
                        },
                        {
                            title: `${t('serial_name')}/${t('passport_number')}`,
                            sorter: false,
                            dataIndex: 'serial_name',
                            key: 'serial_name',
                            //width: "10rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => {
                                const staffData = record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true);
                                const hasSerialName = staffData?.staff_serial_name !== '';
                                const isForigen = staffData?.staff_serial_name_forigen === 1;
                                
                                return (
                                    <>
                                        <Row justify={'center'} style={{ color: isForigen ? 'red' : 'black' }}>
                                            <Col>
                                                {hasSerialName
                                                    ? staffData?.staff_serial_name
                                                    : staffData?.passport_number}
                                            </Col>
                                        </Row>
                                    </>
                                );
                            }
                        },
                        { 
                            title: t('user_department_role_data'),
                            sorter: false,
                            dataIndex: 'user_department_role_data',
                            key: 'user_department_role_data',
                            //width: "10rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, item) => {
                                const record = item?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)
                                return <>
                                    <Row>
                                        {record?.user_department_role_data && record?.user_department_role_data.map((item) => (<>
                                            <Col>
                                                <Tag color="geekblue">
                                                    {
                                                        item?.role_name_language_data?.[0]?.language_culture_value ?? ''
                                                    }
                                                    {item?.user_role_department_data && <>
                                                        －
                                                        {item?.user_role_department_data?.map(itemItem => itemItem?.department_language_data?.[0]?.language_culture_value ?? '').join('、')}
                                                    </>}
                                                </Tag>
                                            </Col>
                                        </>))}
                                    </Row>
                                </>
                            }
                        },
                        {
                            title: t('staff_name'),
                            sorter: false,
                            dataIndex: 'staff_name',
                            key: 'staff_name',
                            //width: "10rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.staff_name}
                                </Row>
                            </>
                        },
                        {
                            title: t('birthday'),
                            sorter: false,
                            dataIndex: 'birthday',
                            key: 'birthday',
                            //width: "8rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.birthday}
                                </Row>
                            </>
                        },
                        //{     //john disabled 2025-12-12
                        //    title: t('birthday_lunar'),
                        //    sorter: true,
                        //    dataIndex: 'lunar_birthday',
                        //    key: 'lunar_birthday',
                        //    width: "10rem",
                        //    canFilter: true,
                        //    filterType: "search",
                        //    render: (text, record) => <>
                        //        <Row justify={'center'}>
                        //            {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.lunar_birthday}
                        //        </Row>
                        //    </>
                        //},
                        {
                            title: t('staff_phone'),
                            sorter: false,
                            dataIndex: 'staff_phone',
                            key: 'staff_phone',
                            //width: "8rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.staff_phone}
                                </Row>
                            </>
                        },
                        {
                            title: t('address'),
                            sorter: false,
                            dataIndex: 'address',
                            key: 'address',
                            //width: "10rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.address}
                                </Row>
                            </>
                        },
                        {
                            title: t('email'),
                            sorter: false,
                            dataIndex: 'email',
                            key: 'email',
                            //width: "10rem",
                            canFilter: false,
                            filterType: "search",
                            render: (text, record) => <>
                                <Row justify={'center'}>
                                    {record?.natural_person_task_data.find(_ => true)?.natural_person_staff_data?.find(_ => true)?.email}
                                </Row>
                            </>
                        },
                    ]}
                    // extraActionRender={(item) => {
                    //     let transfer_data = {
                    //         ...item?.sop_data?.find(_ => true),
                    //         self: false
                    //     }
                    //     return (<>{(item?.application_submitted === 0) ? <></> :
                    //         <Row gutter={[8, 8]}>
                    //             <Col span={24}>
                    //                 <Button
                    //                     variant={"sop_display"}
                    //                     style={{
                    //                         color: '#3FA68C'
                    //                     }}
                    //                     onClick={() => {
                    //                         navigate('../sop_display', { state: transfer_data || {} });
                    //                     }}
                    //                 >
                    //                     {t('sop_display')}
                    //                 </Button>
                    //             </Col>
                    //         </Row>}
                    //     </>)
                    // }}
                    toolBarRender={(item) => {
                        return ([
                            ...item,
                            // <Button></Button>
                        ])
                    }}
                    customFormItems={(fieldName, formValues, onValuesChange = () => { }, propsCustomForm, field, propsOnFinish) => {
                        return (<>
                            <NaturePersonFormItems
                                fieldName={fieldName}
                                formValues={formValues}
                                propsCustomForm={propsCustomForm}
                                field={field}
                                propsOnFinish={propsOnFinish}
                                keyPrefix={keyPrefix}
                                propsShowKeys={propsShowKeys}
                                formOnValuesChange={formOnValuesChange}
                                departmentMode={departmentMode}
                            />
                        </>)
                    }}
                    propsRowKey='task_id'
                    showDefaultColumn={true}
                    propsShowKeys={propsShowKeys}
                    // propsDefaultAxiosMode={mode === "self" ? "post" : undefined}
                    filterMode="create_time"
                    propsWidth={700}
                    formMode
                    propsSubmit={true}
                    formOnValuesChange={formOnValuesChange}
                    propsInitialValues={{
                        synchronous_appointment: 1,
                        start_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                    }}
                    reorganizeFormData={(data, type) => {
                        const formValues = data.map(item => ({
                            ...item,
                            natural_person_task_data: item?.natural_person_task_data?.map(itemItem => (
                                {
                                    ...itemItem,
                                    natural_person_staff_data: itemItem?.natural_person_staff_data?.map(itemItemItem => (
                                        {
                                            ...itemItemItem,
                                            user_language_data: itemItemItem?.user_department_role_data
                                        }
                                    )),
                                    natural_person_area_data: [
                                        {
                                            area_id: 4,
                                            area_position_data: [
                                                {
                                                    position_id: 422
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ))
                        }))
                        return [...formValues]
                    }}
                />
            </Col>
        </Row >
    )
}

export default NaturePersonManagement
export { NaturePersonFormItems }